import { useState } from "react";

import { NamePath } from "antd/lib/form/interface";

import { RVEditable, RVFormItem } from "@regal-voice/ui";
import { Row } from "Components/shared/Flexbox";
import { RemoveButton } from "Pages/audience/Pages/SegmentsPage/Pages/SegmentEditPage/ConditionsList/Shared/Buttons";

import type { FormInstance } from "antd";

// todo this should be shared once we have more
import styles from "./RVEditableFormItemPanelHeader.module.scss";

const DEFAULT_NAME = "Value";

export function RVEditableFormItemPanelHeader({
    form,
    panelIndex,
    hideConditionRemove,
    remove,
    disabled,
    noIndex = false,
    name = DEFAULT_NAME,
    formItemName = "name",
}: {
    form: FormInstance;
    panelIndex: number;
    name?: string;
    hideConditionRemove?: boolean;
    formItemName?: NamePath<any>;
    disabled?: boolean;
    noIndex?: boolean;
    remove: (panelIndex: number) => void;
}) {
    const panelName = noIndex ? name : `${name} ${panelIndex + 1}`;
    const [panelTitle] = useState(form.getFieldValue(formItemName) || panelName);

    return (
        <Row
            alignItems="center"
            justifyContent="space-between"
            onClick={(event) => {
                event.stopPropagation();
            }}
            className={styles.panelHeader}
        >
            <div className={styles.editWrapper}>
                <RVFormItem name={formItemName}>
                    {disabled ? (
                        <div className={styles.disabledPanelTitle}>{panelTitle}</div>
                    ) : (
                        <RVEditable inputClassName={styles.customInput} defaultValue={panelTitle} />
                    )}
                </RVFormItem>
                {!hideConditionRemove && <RemoveButton onClick={() => remove(panelIndex)} />}
            </div>
        </Row>
    );
}
